import { Grid } from "@mui/joy";
import LoadingTag from "./LoadingTag";

function LoadingBox(props) {
    return <Grid container>
        <Grid xs={4}></Grid>
        <Grid xs={4} sx={{
            height: "400px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"

        }}><LoadingTag /></Grid>
        <Grid xs={4}></Grid>
    </Grid>
}

export default LoadingBox;